<template>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{
                $route.params.userId === "new"
                    ? t("Add new")
                    : `${activeUser.first_name ? activeUser.first_name : "-"} ${
                          activeUser.last_name ? activeUser.last_name : ""
                      }`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <div class="pa-5 compact-form" v-if="activeUser">
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ "First name" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="activeUser.first_name"
                                @input="updateField($event, 'first_name')"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ "Last name" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="activeUser.last_name"
                                @input="updateField($event, 'last_name')"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ "Email" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="activeUser.email"
                                @input="updateField($event, 'email')"
                                class="text-field-item mb-1"
                                :rules="[
                                    v =>
                                        !v ||
                                        /^\w+([.+-]?\w+)*@\w+([.+-]?\w+)*(\.)\w+$/.test(v) ||
                                        this.t('E-mail must be valid')
                                ]"
                                hide-details
                                dense
                                outlined
                                :disabled="$route.params.userId !== 'new'"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ "Phone number" | t }}</v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="activeUser.phone_number"
                                @input="updateField($event, 'phone_number')"
                                class="text-field-item mb-1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col class="mt-2 row-title" cols="3">{{ "Status" | t }}</v-col>
                        <v-col cols="6">
                            <v-select
                                :value="activeUser.user_status"
                                @input="updateField($event, 'user_status')"
                                class="text-field-item mb-1"
                                :items="status_types"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <div
                        v-if="
                            user.role === 'admin' &&
                                activeUser &&
                                activeUser.user_companies &&
                                activeUser.user_companies.length > 0
                        "
                    >
                        <div v-for="(company, idx) in activeUser.user_companies" :key="'c_' + company.id">
                            <div v-if="!company.is_deleted">
                                <v-divider class="mt-3 mb-3" />
                                <v-row no-gutters>
                                    <v-col class="mt-2 row-title" cols="3">{{ "Company" | t }}</v-col>
                                    <v-col cols="6">
                                        <v-select
                                            v-model="company.name"
                                            :value="company.name"
                                            @input="updateCompanyField($event, 'name', idx)"
                                            class="text-field-item mb-1"
                                            :items="new_user_companies"
                                            hide-details
                                            dense
                                            outlined
                                            v-if="company.is_new"
                                        />
                                        <v-text-field
                                            :value="company.name"
                                            class="text-field-item mb-1"
                                            disabled
                                            hide-details
                                            dense
                                            outlined
                                            v-else
                                        />
                                    </v-col>
                                    <v-col v-if="$route.params.userId !== 'new'">
                                        <v-btn
                                            class="grey--text ml-2 align-self-baseline"
                                            style="text-align: right"
                                            small
                                            @click="removeCompany(idx)"
                                        >
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col class="mt-2 row-title" cols="3">{{ "Company role" | t }}</v-col>
                                    <v-col cols="6">
                                        <v-select
                                            :value="company.role"
                                            @input="updateCompanyField($event, 'role', idx)"
                                            class="text-field-item mb-1"
                                            :items="company_role_types"
                                            hide-details
                                            dense
                                            outlined
                                        />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                        <v-btn v-if="$route.params.userId !== 'new'" class="grey--text mr-2" @click="addNewCompany">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "user-edit",
    data() {
        return {
            status_types: ["active", "pending", "inactive", "blocked"],
            company_role_types: ["owner", "customer"],
            tabs: ["User info"],
            new_user_companies: [],
            tab: 0
        };
    },
    computed: {
        ...mapState(["user", "activeUser", "companies", "activeCompany"])
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.userId === "new") {
            this.status_types = ["pending"];
            Store.commit("addNewUser");
            Store.dispatch("getCompanies").then(() => (this.new_user_companies = this.companies.map(x => x.name)));
            this.activeUser.user_status = this.status_types[0];
        } else if (this.user.role === "admin") {
            Store.commit("setActiveCompany");
            Store.dispatch("getCompanies").then(() => (this.new_user_companies = this.companies.map(x => x.name)));
            Store.dispatch("getUserData", this.$route.params.userId);
        } else {
            Store.dispatch("getUserData", this.$route.params.userId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        updateField(value, field) {
            Store.commit("updateActiveUserProperty", { prop: field, value: value });
        },
        updateCompanyField(value, field, index) {
            Store.commit("updateActiveUserCompanyProperty", { prop: field, value: value, index: index });
        },
        addNewCompany() {
            Store.commit("addActiveUserCompany");
        },
        removeCompany(index) {
            Store.commit("removeActiveUserCompany", index);
        },
        closeDrawer() {
            this.$router.push({ name: "users-list" });
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (document.activeElement.tagName !== "INPUT" && document.activeElement.tagName !== "TEXTAREA") {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        },
        async submitEdit() {
            if (this.activeUser) {
                const response = await Store.dispatch("submitUserUpdate", this.activeUser);
                if (response && response.status === 1) {
                    await this.$router.push({
                        name: "user-view",
                        params: { userId: response.id, tab: this.tabs[this.tab] }
                    });
                    await Store.dispatch("getUsers");
                    await Store.commit("setRequestSuccess", true);
                } else {
                    await Store.commit("setRequestError", true);
                    //await Store.commit("setErrorMessage", "Failed");

                    console.log(response);
                }
            } else {
                await Store.commit("setRequestError", true);
                await Store.commit("setErrorMessage", "Failed");
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
